// extracted by css-extract-rspack-plugin
export default {"text":"truncated-list_text__i+xNU","overflowContainer":"truncated-list_overflowContainer__uKMep","moreCount":"truncated-list_moreCount__25KhK"};